import React from 'react';
import { InvoiceData } from '../types';

interface PatientInfoProps {
  invoice: InvoiceData;
  layout?: 'grid' | 'inline' | 'compact' | 'column';
}

export default function PatientInfo({ invoice, layout = 'grid' }: PatientInfoProps) {
  const { patient, invoice_number, issue_date, due_date } = invoice;

  if (layout === 'column') {
    return (
      <div
        style={{
          fontFamily: 'Inter, "Noto Sans Bengali", Arial, sans-serif',
        }}
      >
        <div className="font-semibold mb-1">Patient Information</div>
        <div className="space-y-0.5 text-[13px]">
          <div><span className="font-semibold">ID:</span> {patient.unique_id}</div>
          <div><span className="font-semibold">Name:</span> {patient.name}</div>
          {patient.phone && <div><span className="font-semibold">Phone:</span> {patient.phone}</div>}
          {patient.address && <div><span className="font-semibold">Address:</span> {patient.address}</div>}
        </div>
      </div>
    );
  }

  if (layout === 'inline') {
    return (
      <div className="mb-4 text-sm">
        <p><span className="font-semibold">Patient:</span> {patient.name} ({patient.unique_id})</p>
        <p><span className="font-semibold">Invoice:</span> {invoice_number} | <span className="font-semibold">Date:</span> {new Date(issue_date).toLocaleDateString()}</p>
      </div>
    );
  }

  if (layout === 'compact') {
    return (
      <div className="mb-4 p-3 bg-gray-50 rounded text-sm">
        <div className="flex justify-between mb-1">
          <span className="font-semibold">Patient ID:</span>
          <span>{patient.unique_id}</span>
        </div>
        <div className="flex justify-between mb-1">
          <span className="font-semibold">Patient Name:</span>
          <span>{patient.name}</span>
        </div>
        <div className="flex justify-between">
          <span className="font-semibold">Invoice No:</span>
          <span>{invoice_number}</span>
        </div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 gap-4 mb-6">
      <div>
        <h3 className="text-sm font-semibold text-gray-700 mb-2">Patient Information</h3>
        <div className="text-sm space-y-1">
          <p><span className="font-medium">ID:</span> {patient.unique_id}</p>
          <p><span className="font-medium">Name:</span> {patient.name}</p>
          {patient.phone && <p><span className="font-medium">Phone:</span> {patient.phone}</p>}
          {patient.age && <p><span className="font-medium">Age:</span> {patient.age} years</p>}
          {patient.gender && <p><span className="font-medium">Gender:</span> {patient.gender}</p>}
          {patient.address && <p><span className="font-medium">Address:</span> {patient.address}</p>}
        </div>
      </div>
      <div>
        <h3 className="text-sm font-semibold text-gray-700 mb-2">Invoice Details</h3>
        <div className="text-sm space-y-1">
          <p><span className="font-medium">Invoice No:</span> {invoice_number}</p>
          <p><span className="font-medium">Issue Date:</span> {new Date(issue_date).toLocaleDateString()}</p>
          {due_date && <p><span className="font-medium">Due Date:</span> {new Date(due_date).toLocaleDateString()}</p>}
          <p><span className="font-medium">Status:</span> <span className={`px-2 py-0.5 rounded text-xs ${
            invoice.status === 'paid' ? 'bg-green-100 text-green-800' :
            invoice.status === 'partial' ? 'bg-yellow-100 text-yellow-800' :
            'bg-red-100 text-red-800'
          }`}>{invoice.status.toUpperCase()}</span></p>
        </div>
      </div>
    </div>
  );
}
